export default function HelpCenterStaffSearchIllustration() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="118"
      height="119"
      viewBox="0 0 118 119"
      fill="none"
      className="h-full w-full"
      aria-hidden
    >
      <path
        d="M87.3816 40.019L96.2594 41.7686L94.2329 28.6438L88.7734 28.7557C88.8076 28.9868 88.8431 29.2106 88.8639 29.4417C89.0657 31.206 88.9617 32.9765 88.7391 34.5589C88.294 37.667 87.3816 40.019 87.3816 40.019Z"
        fill="#F9B384"
      />
      <path
        d="M88.7391 34.5589C92.1513 32.9421 93.4184 29.5462 93.4184 29.5462L88.8639 29.4417C89.0657 31.206 88.9617 32.9765 88.7391 34.5589Z"
        fill="#102048"
      />
      <path
        d="M86.8618 21.1746C86.5133 22.3992 84.5406 30.1585 88.1386 31.0327C91.7367 31.9081 95.4498 28.5823 95.4498 28.5823L94.2317 21.1156L89.0094 19.5406L86.8631 21.1734L86.8618 21.1746Z"
        fill="#F9B384"
      />
      <path
        d="M91.6267 25.3967C91.6267 25.3967 90.6911 19.1914 86.8618 21.1746C86.9988 21.1033 87.1969 20.4849 87.2825 20.3435C87.669 19.7066 88.1655 19.1287 88.766 18.6874C90.9454 17.0816 94.6206 17.6656 96.378 19.5123C98.1086 21.3308 98.1624 24.5619 97.2708 26.9114C97.1265 27.2913 96.9443 27.6565 96.7254 27.9983C96.526 28.3094 96.2912 28.5675 96.0258 28.8233C95.7983 29.0434 94.0898 30.3958 94.0714 29.3557C94.0274 26.818 91.6267 25.3967 91.6267 25.3967Z"
        fill="#4B4F55"
      />
      <path
        d="M93.1577 26.3179C93.8176 25.5069 93.8243 24.4152 93.1729 23.8795C92.5214 23.3439 91.4584 23.5671 90.7986 24.3781C90.1387 25.1891 90.132 26.2808 90.7834 26.8165C91.4349 27.3521 92.4979 27.1289 93.1577 26.3179Z"
        fill="#F9B384"
      />
      <path
        d="M86.1378 26.4688C86.5856 26.4688 86.9487 26.0725 86.9487 25.5836C86.9487 25.0947 86.5856 24.6983 86.1378 24.6983C85.69 24.6983 85.327 25.0947 85.327 25.5836C85.327 26.0725 85.69 26.4688 86.1378 26.4688Z"
        fill="#F9B384"
      />
      <path
        d="M97.771 90.6507L108.332 95.2011C108.332 95.2011 99.6276 117.484 97.0751 118.885C94.5215 120.285 95.7983 107.918 94.058 104.185L91.8529 95.4347L97.771 90.6507Z"
        fill="#004578"
      />
      <path
        d="M98.608 103.299L94.0242 103.62L94.1015 104.736L98.6852 104.415L98.608 103.299Z"
        fill="#004578"
      />
      <path
        d="M100.44 89.0167L94.0568 104.184C94.0568 104.184 69.2212 91.1167 63.0707 79.2164L72.8193 66.383L100.44 89.0167Z"
        fill="#9EA9AD"
      />
      <path
        d="M67.1335 101.267C67.1335 101.267 55.5284 101.735 50.19 92.5171L62.0275 90.7675L67.1335 101.267Z"
        fill="#102048"
      />
      <path
        d="M48.9805 102.86L62.0727 107.51L63.1282 103.755L65.0471 96.9531L54.1342 91.761L53.3674 93.4146L48.9805 102.86Z"
        fill="#F9B384"
      />
      <path
        d="M32.4332 119L46.7656 107.626L48.978 102.862L62.0715 107.508L58.8354 119H32.4332Z"
        fill="#004578"
      />
      <path
        d="M47.2058 107.277L46.3312 107.967L49.2907 111.758L50.1653 111.068L47.2058 107.277Z"
        fill="white"
      />
      <path
        d="M53.3674 93.4146L63.1282 103.755L65.0471 96.9531L54.1342 91.761L53.3674 93.4146Z"
        fill="#E28B6D"
      />
      <path
        d="M50.1863 92.5159C56.3576 94.081 61.9993 97.0035 67.1311 101.267L75.9538 77.9341C75.9538 77.9341 93.7547 94.9908 104.384 92.1691C114.485 89.4864 110.077 72.6817 110.077 72.6817C96.2068 62.9183 74.1426 49.807 64.4747 60.1913C64.4246 60.2356 64.3854 60.2749 64.3463 60.3204C62.3675 62.5052 60.1318 66.8256 58.0307 71.6096C53.8395 81.1381 50.1863 92.5171 50.1863 92.5171V92.5159Z"
        fill="#9EA9AD"
      />
      <path
        d="M58.0307 71.6084C67.6484 73.8829 77.5437 63.1421 77.5437 63.1421L67.6044 59.8618L64.4747 60.1913C64.4246 60.2356 64.3854 60.2749 64.3463 60.3204C62.3675 62.5052 60.1318 66.8256 58.0307 71.6096V71.6084Z"
        fill="#4B4F55"
      />
      <path
        d="M67.3916 101.367L76.0651 78.4296C77.9461 80.2259 88.1802 89.6401 98.9696 92.4986L99.1115 91.9589C87.3669 88.8471 76.262 77.8468 76.1507 77.7361L75.8474 77.4325L66.873 101.168L67.3928 101.367H67.3916Z"
        fill="#4B4F55"
      />
      <path
        d="M95.7726 35.1478L99.6691 47.8115L104.911 64.8462C104.911 64.8462 108.735 66.2269 112.11 65.7966C115.089 65.4166 117.718 63.6167 117.008 58.1786C115.44 46.1911 95.7714 35.1478 95.7714 35.1478H95.7726Z"
        fill="#E13D2F"
      />
      <path
        d="M99.6691 47.8115L104.911 64.8462C104.911 64.8462 108.735 66.2269 112.11 65.7966C109.28 48.3095 99.9186 40.86 99.9186 40.86L99.6679 47.8128L99.6691 47.8115Z"
        fill="#9C3325"
      />
      <path
        d="M57.6479 47.6824L60.5489 58.7934L70.3451 49.5046L66.4584 42.9551L57.6479 47.6824Z"
        fill="#E13D2F"
      />
      <path
        d="M66.4364 42.9661L62.7197 36.9933L55.2092 33.7744L57.6699 47.7046L66.4364 42.9661Z"
        fill="#F9B384"
      />
      <path
        d="M38.4455 34.281C39.9632 33.9158 41.3306 33.9761 42.567 34.431C43.384 34.7322 44.1447 35.2093 44.8455 35.8535L47.6376 29.347C46.6678 29.1749 45.7823 28.8823 44.9825 28.4569C43.8243 27.8421 42.8581 26.9532 42.1059 25.7446L38.4467 34.2798L38.4455 34.281Z"
        fill="#004578"
      />
      <path
        d="M44.8381 35.8486L47.6278 29.3434L88.7257 48.9562L87.241 52.4197L44.8381 35.8486Z"
        fill="#004578"
      />
      <path
        d="M38.4455 34.281C39.9632 33.9158 41.3306 33.9761 42.567 34.431L44.9825 28.4569C43.8243 27.8421 42.8581 26.9532 42.1059 25.7446L38.4467 34.2798L38.4455 34.281Z"
        fill="#004578"
      />
      <path
        d="M1.79911 13.3401C6.59941 2.14676 19.5168 -3.0171 30.6523 1.80865C41.7877 6.63441 46.9231 19.6203 42.1228 30.8148C37.3225 42.0093 24.4051 47.172 13.2697 42.3462C2.13544 37.5217 -3.00118 24.5346 1.79911 13.3401ZM14.7202 38.9639C23.9967 42.9843 34.7591 38.6823 38.7583 29.3566C42.7576 20.0309 38.4783 9.21142 29.2018 5.19098C19.9253 1.17055 9.16283 5.47254 5.1636 14.7982C1.16437 24.1239 5.44367 34.9435 14.7202 38.9639Z"
        fill="#004578"
      />
      <path
        d="M57.6479 47.6824L61.2056 45.7706L59.0372 41.037C59.0372 41.037 56.0189 35.5547 54.5121 35.7896C53.0054 36.0183 57.6479 47.6824 57.6479 47.6824Z"
        fill="#F9B384"
      />
      <path
        d="M70.3427 49.5046L71.0814 50.7513C72.5502 48.7214 75.7887 44.3948 79.8613 40.9584C83.5242 37.8711 88.4933 33.0699 92.8313 33.7351C104.446 35.5056 110.074 72.6829 110.074 72.6829L80.0216 61.7466L73.2889 67.0199C71.825 68.167 69.9831 68.7154 68.1339 68.5543C65.0275 68.285 62.4262 66.0769 61.6422 63.0425L60.5464 58.7971L70.3415 49.5058L70.3427 49.5046Z"
        fill="#E13D2F"
      />
      <path
        d="M87.9911 54.2681L79.8379 61.5324L80.2062 61.9502L88.3594 54.6858L87.9911 54.2681Z"
        fill="#9C3325"
      />
      <path
        d="M71.666 49.5956L66.7547 56.5818L67.2082 56.904L72.1195 49.9178L71.666 49.5956Z"
        fill="#9C3325"
      />
    </svg>
  );
}
